module.exports = __webpack_public_path__ + "img/bg.4f37c153.svg";